var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.8559H10.9578L10.708 2.17904C10.6678 1.97525 10.5702 1.87336 10.4152 1.87336H7.89147V11.7686C7.89147 11.8559 7.92018 11.9403 7.97761 12.0218C8.04077 12.1033 8.13552 12.1499 8.26184 12.1616L9.39018 12.2314V13H4.60982V12.2314L5.73816 12.1616C5.86448 12.1499 5.95636 12.1033 6.01378 12.0218C6.07695 11.9403 6.10853 11.8559 6.10853 11.7686V1.87336H3.56761C3.38386 1.87336 3.28338 1.97525 3.26615 2.17904L3.02498 3.8559H2V1H12V3.8559Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTLetter);
export default __webpack_public_path__ + "static/media/tLetter.2c57e732822d90bca578059a583eb62f.svg";
export { ForwardRef as ReactComponent };